class GiftUpsells extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("someValueChange", this.handle_value_change);

        this.noteVariantInputs = this.querySelectorAll(".gift-upsells-note-variant-input");
        this.ribbonVariantInputs = this.querySelectorAll(".gift-upsells-ribbon-variant-input");
        this.ribbonCheckbox = this.querySelector("#gift-upsells-ribbon-checkbox-input");
        this.ribbonVariantsContainer = this.querySelector(".gift-upsells-ribbon-check-variants-container");

        this.allowSubscriptions = this.getAttribute("data-allow-subscription") === "true";
        this.sellingPlans = this.getAttribute("data-selling-plans") ? JSON.parse(this.getAttribute("data-selling-plans")) : [];
        this.formProduct = document.querySelector(".shopify-product-form");

        this.previousNoteRadio = null;
        this.ribbonVariantValue = this.querySelector(".gift-upsells-ribbon-variant-input:checked");
        this.noteVariantValue = null;

        // Attach event listeners only if elements exist
        this.noteVariantInputs?.forEach(el => el.addEventListener("click", this.handle_radio_note_change));
        this.ribbonVariantInputs?.forEach(el => el.addEventListener("click", this.handle_radio_ribbon_change));
        this.ribbonCheckbox?.addEventListener("change", this.handle_checkbox_ribbon_change);

        this.listeners();
    }

    handle_value_change = () => {
        if (!this.formProduct) return;

        const ribbonInput = this.formProduct.querySelector("input[name='properties[Ribbon]']");
        const noteInput = this.formProduct.querySelector("input[name='properties[Note]']");

        if (this.ribbonCheckbox?.checked && this.ribbonVariantValue) {
            if (ribbonInput) {
                ribbonInput.value = this.ribbonVariantValue.getAttribute("data-title") || "";
            } else {
                const newInput = document.createElement("input");
                newInput.type = "hidden";
                newInput.name = "properties[Ribbon]";
                newInput.value = this.ribbonVariantValue.getAttribute("data-title") || "";
                this.formProduct.append(newInput);
            }
        } else {
            ribbonInput?.remove();
        }

        if (this.noteVariantValue) {
            if (noteInput) {
                noteInput.value = this.noteVariantValue.getAttribute("data-title") || "";
            } else {
                const newInput = document.createElement("input");
                newInput.type = "hidden";
                newInput.name = "properties[Note]";
                newInput.value = this.noteVariantValue.getAttribute("data-title") || "";
                this.formProduct.append(newInput);
            }
        } else {
            noteInput?.remove();
        }
    };

    handle_radio_note_change = (e) => {
        const el = e.currentTarget;
        if (el === this.previousNoteRadio) {
            el.checked = false;
            this.previousNoteRadio = null;
            this.noteVariantValue = null;
        } else if (el.checked) {
            this.previousNoteRadio = el;
            this.noteVariantValue = el;
        }
        this.dispatchEvent(new CustomEvent("someValueChange"));
    };

    handle_checkbox_ribbon_change = () => {
        if (this.ribbonCheckbox?.checked) {
            this.ribbonVariantsContainer?.removeAttribute("data-hidden");
        } else {
            this.ribbonVariantsContainer?.setAttribute("data-hidden", "");
        }
        this.dispatchEvent(new CustomEvent("someValueChange"));
    };

    handle_radio_ribbon_change = (e) => {
        this.ribbonVariantValue = e.currentTarget;
        this.dispatchEvent(new CustomEvent("someValueChange"));
    };

    handle_add_to_cart = async () => {
        if (this.adding_to_cart) return;
        this.adding_to_cart = true;

        const formData = { items: [] };
        const sellingPlanContainer = document.querySelector("skio-plan-picker");
        const selectedPlanId = sellingPlanContainer?.querySelector("[name='selling_plan']")?.value;

        if (this.ribbonCheckbox?.checked && this.ribbonVariantValue) {
            const item = {
                id: this.ribbonVariantValue.value,
                quantity: 1,
            };

            if (selectedPlanId != 0 && this.allowSubscriptions) {
                const selectedPlan = this.sellingPlans.find(plan => plan.id == selectedPlanId);
                if (selectedPlan) {
                    const currentSellingPlans = JSON.parse(this.ribbonVariantValue.getAttribute("data-selling-plans") || "[]");
                    const currentSellingPlan = currentSellingPlans.find(plan => plan.name == selectedPlan.name);
                    if (currentSellingPlan) {
                        item["selling_plan"] = currentSellingPlan.id;
                    }
                }
            }
            formData.items.push(item);
        }

        if (this.noteVariantValue) {
            formData.items.push({ id: this.noteVariantValue.value, quantity: 1 });
        }

        if (formData.items.length) {
            try {
                const responseFetch = await fetch("/cart/add.js?some_flag_parameter=true", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(formData),
                }).then(res => res.json());

                if (responseFetch) {
                    console.log("Items added");
                }
            } catch (e) {
                console.log("Error:", e);
            }
        }

        this.adding_to_cart = false;
    };

    listeners = () => {
        if (!window.fetch) return;

        const handle_add_to_cart = this.handle_add_to_cart;
        const thisDebounce = this.debounce;

        (function (ns, fetch) {
            ns.fetch = async (...args) => {
                const response = fetch.apply(this, args);
                response.then(async (res) => {
                    if (res.url.includes("/cart/add") && !res.url.includes("?some_flag_parameter=true")) {
                        const send = thisDebounce(handle_add_to_cart, 1000);
                        send();
                    }
                });
                return response;
            };
        })(window, window.fetch);
    };

    debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(this, args), delay);
        };
    };
}

if (!customElements.get("gift-upsells")) {
    customElements.define("gift-upsells", GiftUpsells);
}